<template>
  <el-row type="flex" align="middle" style="height: 60px;background-color: #0E131A;color: #ffffff;">
    <el-col :span="6" class="flex-middle">
      <template v-if="appInfo">
        <el-image :src="appInfo.logoUrl" class="circle" style="margin-left: 20px;height: 36px;width: 36px;"></el-image>
        <span style="margin-left: 10px;font-size: 14px;">湖北音协会员申请平台</span>
      </template>
    </el-col>
    <el-col :span="18" class="text-right" style="color: #aaaaaa;">
      <div style="display: inline-block;" v-if="currentUserInfo.vipApply != null">
        <span v-if="currentUserInfo.vipApply.auditStatus != 0"
              @click="query" style="margin-right: 20px;display: inline-block;background: #f5f2f0;padding: 5px 10px;color:#000;border-radius:10px;">查询申请结果</span>
      </div>
      <div v-if="false" class="inline-block" style="margin-right: 20px;">
        <i class="icon icon_notification-filling"></i>
      </div>
      <span v-if="currentUserInfo.vipApply !=null" style="margin-right: 20px;">{{currentUserInfo.vipApply.userName}}</span>
      <div class="inline-block pointer" @click="logout">
        <span style="margin-right: 5px;">退出</span>
        <i class="icon icon_exit" style="margin-right: 20px;"></i>
      </div>
    </el-col>
  </el-row>
</template>
<script>

export default {
  name: 'page-top',
  components: {},
  props: [],
  data () {
    return {
      currentUserInfo: this.$store.state.currentUserInfo,
      appInfo: this.$store.state.appInfo
    }
  },
  async created () {
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async logout () {
      try {
        let confirm = await this.$confirm('确定要退出登录吗？', '提示', { type: 'warning' })
        if (confirm === 'confirm') {
          this.$router.push('/index/login')
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async query () {
      try {
        let info = await this.$HTTP.ApiUser.getQuery()
        console.log(info);
        if (info == 0) {
          await this.$confirm('暂时没有审核结果，请稍等', '提示', { type: 'warning' })
        } else if (info == 1) {
          await this.$confirm('暂时没有审核结果，请稍等', '提示', { type: 'warning' })
        } else if (info == 2) {
          await this.$confirm('暂时没有审核结果，请稍等', '提示', { type: 'warning' })
        } else if (info == 3) {
          await this.$confirm('暂时没有审核结果，请稍等', '提示', { type: 'warning' })
        } else if (info == 4) {
          await this.$confirm('恭喜您，您的会员申请已通过', '提示', { type: 'success' })
        } else if (info == 5) {
          await this.$confirm('很遗憾，您的会员申请没有通过', '提示', { type: 'warning' })
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    }
  }
}
</script>
